import React from 'react';
import { useTranslation } from 'react-i18next';
import ServiceCarousel from '../components/ui/ServiceCarousel';

const ServicesPage = () => {
  const { t } = useTranslation();

  return <ServiceCarousel t={t} />;
};

export default ServicesPage;
